import React from "react";
import { Typography, Stack, styled } from "@mui/material";
import HyroIconButton from "@hyro-components/hyro-icon-button/HyroIconButton";
import { ICON_BUTTON_VARIANTS, ICON_BUTTON_SIZES } from "@hyro-components/hyro-icon-button/HyroIconButton.consts";
import CopyIcon from "src/icons/CopyIcon";
import { NOTIFICATION_TYPES } from "../notifications.consts";
import Tooltip from "@hyro-components/Tooltip";
import CopyPopper from "@hyro-components/CopyPopper";
import { TOOLTIP_DELAY } from "@consts";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";

const ERROR_TITLE = {
  [NOTIFICATION_TYPES.BUILD]: "Build failed",
  [NOTIFICATION_TYPES.PUBLISH]: "Publish failed",
  [NOTIFICATION_TYPES.PREVIEW]: "Preparing preview failed"
};

const NotificationErrorBox = ({ notificationType, errorId }) => (
  <StyledContainer>
    <Typography variant="subtitle2" color="error.600">{ERROR_TITLE[notificationType]}</Typography>

    <Stack sx={{ gap: 2 }}>
      {errorId && (
        <StyledErrorIdSection>
          <Typography variant="chip">Error ID</Typography>

          <StyledErrorIdStack>
            <Tooltip title={errorId} enterDelay={TOOLTIP_DELAY.LONG} enterNextDelay={TOOLTIP_DELAY.LONG}>
              <HyroTruncateTypography variant="caption" maxWidth="245px">{errorId}</HyroTruncateTypography>
            </Tooltip>

            <CopyPopper copyText={errorId}>
              <HyroIconButton variant={ICON_BUTTON_VARIANTS.CLEAR} size={ICON_BUTTON_SIZES.MEDIUM}>
                <CopyIcon strokeOpacity={1} />
              </HyroIconButton>
            </CopyPopper>
          </StyledErrorIdStack>
        </StyledErrorIdSection>
      )}

      <Typography variant="caption" color="error.600">This action couldn't be completed due to an error. Please contact support{errorId ? " and provide the error ID above." : "."}</Typography>
    </Stack>
  </StyledContainer>
);

const StyledContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.error[100],
  border: `1px solid ${theme.palette.error[200]}`,
  borderRadius: theme.shape.borderRadius
}));

const StyledErrorIdSection = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.system[0],
  borderRadius: theme.shape.borderRadius * 0.5
}));

const StyledErrorIdStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
  height: "18px"
}));

export default NotificationErrorBox;
